import es from './translations/es';
import de from './translations/de';
import fr from './translations/fr';
import it from './translations/it';
import pt from './translations/pt';
import en from './translations/en';
import type { TranslationKeys } from './translations/es';
import type { Locale } from './types';

export const translations: Record<Locale, TranslationKeys> = {
  es,
  de,
  fr,
  it,
  pt,
  en,
};

export function getTranslations(locale: Locale): TranslationKeys {
  return translations[locale] || translations.es;
}

export type { TranslationKeys };
export { type Locale, SUPPORTED_LOCALES, DEFAULT_LOCALE, LOCALE_CONFIGS, isValidLocale, getLocaleFromPath, localizedPath, ROUTE_TRANSLATIONS } from './types';
